//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class ReviewSummaryDisplayItem extends ItemBase {
    SchoolID: string | null = null;
    TeacherID: string | null = null;
    AverageRating: number = 0;
    TotalRatings: number = 0;

    constructor(initializer?: Partial<ReviewSummaryDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "ReviewSummaryDisplayItem";
}
